export default [
  {
    text: 'Name',
    value: 'name',
  },
  {
    text: 'Labels',
    value: 'labels',
    sortable: false,
  },
];
